import { css } from 'styled-components';
import { hideScrollbar } from './hideScrollbar';
export var scrollX = css(["overflow-x:auto;-webkit-overflow-scrolling:touch;white-space:nowrap;", ""], hideScrollbar);